export const carouselItems = [
  {
    id: 0,
    title: "CloudSous",
    description: "Your automatic A.I. Sous Chef, usable by your fans, so you get paid more for your recipes",
    image: "https://res.cloudinary.com/djrbfvpit/image/upload/v1738176898/CloudSous%20Assets/chefrobomascot_mhxtel.png"
  },
  {
    id: 1,
    title: "24/7 Revenue Stream",
    description: "Fans use your recipes, you get paid, like Spotify artists when you play their songs.",
    image: "https://res.cloudinary.com/djrbfvpit/image/upload/v1739820310/CloudSous%20Assets/moneybags_dmfegw.png"
  },
  {
    id: 2,
    title: "Easy Uploads & Edits",
    description: "Simple recipe uploads and edits for your A.I. Sous' Training",
    image: "https://res.cloudinary.com/djrbfvpit/image/upload/v1739821626/CloudSous%20Assets/editedAItrain_oadqip.png"
  },
  {
    id: 3,
    title: "Revenue Transparency",
    description: "70% of profits go to chefs, including live viewable stats",
    image: "https://res.cloudinary.com/djrbfvpit/image/upload/v1739822245/CloudSous%20Assets/piegraphsmaller_cyu0uv.png"
  },
  // Add more carousel items as needed
];